export default {"src":"/_next/static/image/public/images/ic_no_insurance.840708cdbfc3b50996347eee11f360a6.svg","height":109,"width":100};